module.exports={
	"Form": "ProjectTagTypeViewManifest",
	"Scope": "ProjectTagType-View",
	"Descriptors":
	{
		"ProjectTagTypeDetails.IDProjectTagType":
		{
			"Name": "ID",
			"Hash": "PTTView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "PTTIdentity",
				"Group": "PTTIdentity"
			}
		},
		"ProjectTagTypeDetails.GUIDProjectTagType":
		{
			"Name": "GUID",
			"Hash": "PTTView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "PTTIdentity",
				"Group": "PTTIdentity"
			}
		},
		"ProjectTagTypeDetails.TagType":
		{
			"Name": "Tag Type",
			"Hash": "PTTView-TagType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "PTTIdentity",
				"Group": "PTTIdentity"
			}
		},
		"ProjectTagTypeDetails.Name":
		{
			"Name": "Display Name",
			"Hash": "PTTView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "PTTIdentity",
				"Group": "PTTIdentity"
			}
		},
		"ProjectTagTypeDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "PTTView-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "PTTConfig",
				"Group": "PTTConfig"
			}
		},
		"ProjectTagTypeDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "PTTView-IDProject",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "PTTConfig",
				"Group": "PTTConfig"
			}
		},
		"ProjectTagTypeDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "PTTView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "PTTAudit",
				"Group": "PTTAudit"
			}
		},
		"ProjectTagTypeDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "PTTView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "PTTAudit",
				"Group": "PTTAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PTTIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PTTIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "PTTConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "PTTConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "PTTAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "PTTAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
